<template v-if="options">
    <ui5-combobox
        v-bind="$attrs"
        ref="comboBox"
        filter="Contains"
        @selection-change="selectionChange"
        @change="change">
        <ui5-cb-item
            :text="option.label"
            v-for="option in options"
            :option-value="option.value"
            :key="option.value" />
    </ui5-combobox>
</template>

<script>
export default {
    props: ['options', 'options', 'value'],
    data() {
        return {
            selectedItem: null,
        };
    },
    watch: {
        value(a) {
            this.setSelectedItem(this.value);
        },
        options() {
            this.setSelectedItem(this.value);
        },
    },
    mounted() {
        if (this.selectedItem == null) {
            this.setSelectedItem(this.value);
        }
    },
    methods: {
        setSelectedItem(value) {
            this.selectedItem =
                this.options.find((x) => x.value == this.value) ||
                this.options[0];

            if (this.selectedItem) {
                this.$refs.comboBox.value = this.selectedItem.label;
                this.$refs.comboBox.filterValue = this.selectedItem.label;
            }
        },
        getChildIndex(node) {
            return Array.prototype.indexOf.call(
                node.parentNode.childNodes,
                node
            );
        },
        change(event) {
            const comboBox = this.$refs.comboBox;
            const value = comboBox.value;
            const selectedItemLabel = this.selectedItem
                ? this.selectedItem.label
                : null;
            if (value != selectedItemLabel) {
                this.setSelectedItem(value);
                this.$emit(
                    'input',
                    this.selectedItem ? this.selectedItem.value : null
                );
            }
        },
        selectionChange(event) {
            const comboBox = this.$refs.comboBox;
            const item = event.detail.item;
            const index = this.getChildIndex(item);
            this.selectedItem = this.options[index];
            this.$emit('input', this.selectedItem.value);
        },
    },
};
</script>
